import { Icon } from "@utils/helper";

export function mapValidationErrors(errors) {
  if (Array.isArray(errors)) {
    return errors.map(({ key, value }) => ({
      name: key,
      type: "serverSideError",
      message: value?.[0],
    }));
  } else {
    return Object.keys(errors).map((key) => ({
      name: key,
      type: "serverSideError",
      message: errors[key][0],
    }));
  }
}

export default function handleErrorMsg(error, t) {
  let errMsg = null;

  if (typeof error === "object") {
    const { type, message } = error;
    if (type === "serverSideError") {
      errMsg = message;
    } else {
      if (typeof message === "object" && message.key && message.values) {
        errMsg = t(`validation.${message.key}`, { ...message.values });
      } else if (typeof message === "string") {
        errMsg = t(`validation.${message}`);
      }
    }
  }

  return errMsg ? (
    <div className="flex gap-2">
      <Icon color="#d32f2f" width={21} height={17} id="r1-c3" />
      {errMsg}
    </div>
  ) : null;
}
